// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration - PREVIEW ONLY)
// version  : 1.0
// updated  : 2026-06-17
// protected: NO
// =============================================================================
// Supabase client (frontend) — Auth Google + sesi JWT untuk panggil /api/v2.
// PREVIEW ONLY (FASE 2 migrasi). Tidak mengubah AuthContext lama (MongoDB).
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
